<div
    class="hints-floating{{size ? ' -size-'+size : ''}}{{feel ? ' -feel-'+feel : ' -feel-danger'}}{{ vSide ? ' -vertical-position-'+vSide : ' -vertical-position-bottom'}}{{ hSide ? ' -horizontal-position-'+hSide : ' -horizontal-position-right'}}">
    <div class="hints-floating__inner">

        <div class="hints-floating__msg">{{message}}</div>

        <div class="hints-floating__link" *ngIf="button || defaultButton">
            <button type="button" class="hints-floating__btn" (click)="handleButtonClick($event)">
                {{button || defaultButton}}
            </button>
        </div>

    </div>
</div>